import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./shared";

const FAQS = [
  {
    q: "Is this workshop truly free — and will there be an aggressive sales pitch?",
    a: "Yes, 100% free. The workshop is an educational forensic teardown with real anonymized account case studies. We do demonstrate how Protego AI monitors accounts continuously, but there are no high-pressure countdown gimmicks or artificial pricing games.",
  },
  {
    q: "Does connecting Protego AI pose any risk to our Amazon seller credentials?",
    a: "None. Protego AI is an official Amazon Software Partner and integrates strictly via the official Selling Partner API with read-only permissions. We never request or have access to login passwords, OTPs, or write permissions.",
  },
  {
    q: "Who should attend this workshop?",
    a: "Any Amazon seller who can't afford a surprise suspension — founders, marketplace managers, and brand operators who want to see account health issues before Amazon acts on them.",
  },
  {
    q: "My account is healthy. Why attend?",
    a: "That's exactly who this is for. Every seller in our case studies was 'healthy' the week before deactivation. Green is a receipt for the past — this session teaches you to read what's coming.",
  },
  {
    q: "What if I cannot attend live?",
    a: "Registrants receive the private replay link and forensic checklist within 24 hours of the live broadcast, provided you reserve your seat before capacity is reached.",
  },
];

export const Faq = () => (
  <section data-testid="faq-section" className="bg-white border-y border-slate-200 py-20 lg:py-24">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-indigo-700">
          Questions
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl text-slate-900 mt-3">
          Asked before every session
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-10 border-t border-slate-200">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-slate-200">
              <AccordionTrigger
                data-testid={`faq-question-${i + 1}`}
                className="text-left font-display font-semibold text-slate-900 text-base py-6 hover:text-indigo-700 hover:no-underline transition-colors duration-200"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
